module.exports = ".text-position {\n  padding-left: 0; }\n\n.buttons-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-content: center;\n      -ms-flex-line-pack: center;\n          align-content: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/client/client-card/client-card.scss
// module id = ./web/modern/components/client/client-card/client-card.scss
// module chunks = 0